angular.module('tgaAdmin').service('gameService', [
  '$http',
  '$location',
  'envService',
  'domainService',
  'authService',
  'urlService',
  function ($http, $location, envService, domainService, authService, urlService) {
    const serverAddress = envService.read('serverAddress');
    let game = {};

    function destroy() {}

    function setCurrentGame(g) {
      game = g;
    }

    function currentGame() {
      return game;
    }

    function clearGame() {
      game = {};
    }

    function getGame(gameId, cancelOnRouteChange) {
      return $http({
        method: 'GET',
        url: `${serverAddress}game/${gameId}`,
        cancelOnRouteChange,
        params: {
          domain: domainService.domain,
        },
      }).then(
        (response) => {
          game = response.data;
          return response.data;
        },
        (error) => {
          throw error.data;
        },
      );
    }

    function getGames(params = {}) {
      return $http({
        method: 'GET',
        url: `${serverAddress}game`,
        params,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getGameInfo(gameId) {
      const g = getGames();

      for (let i = 0; i < g.length; i++) {
        if (g[i].game_id === gameId) {
          game = g[i];
          return g[i];
        }
      }

      return false;
    }

    // Includes external games (SCORM)
    function getAllGames(params = {}) {
      return $http({
        method: 'GET',
        url: `${serverAddress}game`,
        params: {
          include_external: true,
          ...params,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getArchivedGames(params = {}) {
      return $http({
        method: 'GET',
        url: `${serverAddress}game`,
        params: {
          is_archived: true,
          ...params,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function addGame(d) {
      // [TAGT-851] Allow copy to a subdomain by not overriding it here.
      if (!d.domain) {
        d.domain = domainService.domain;
      }

      return $http({
        method: 'POST',
        url: `${serverAddress}game`,
        headers: { 'Content-Type': undefined },
        data: d,
        transformRequest(data) {
          const formData = new FormData();

          // Loop through questions groups, add the index of the question group to the video object
          for (let i = 0; i < data.question_groups.length; i++) {
            if (data.question_groups[i].video && data.question_groups[i].video.file) {
              const key = `g-video-${i}`;
              data.question_groups[i].video.index = key;
              formData.append(key, data.question_groups[i].video.file);
            }
          }

          // Loop through the questions, add the index of the question to the video object
          for (let i = 0; i < data.questions.length; i++) {
            if (data.questions[i].video && data.questions[i].video.file) {
              const key = `video-${i}`;
              data.questions[i].video.index = key;
              formData.append(key, data.questions[i].video.file);
            }

            // Advanced feedback
            if (data.questions[i].advanced_feedback) {
              for (let j = 0; j < data.questions[i].advanced_feedback.length; j++) {
                if (data.questions[i].advanced_feedback[j].video && data.questions[i].advanced_feedback[j].video.file) {
                  const key = `adv-video-${i}-${j}`;
                  data.questions[i].advanced_feedback[j].video.index = key;
                  formData.append(key, data.questions[i].advanced_feedback[j].video.file);
                }
              }
            }
          }

          // Append relevant json
          formData.append('data', angular.toJson(data));

          return formData;
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function updateGame(d) {
      return $http({
        method: 'POST',
        url: `${serverAddress}game/update`,
        headers: { 'Content-Type': undefined },
        data: d,
        transformRequest(data) {
          const formData = new FormData();

          // Loop through questions groups, add the index of the question group to the video object
          for (let i = 0; i < data.question_groups.length; i++) {
            if (data.question_groups[i].video && data.question_groups[i].video.file) {
              const key = `g-video-${i}`;
              data.question_groups[i].video.index = key;
              formData.append(key, data.question_groups[i].video.file);
            }

            if (data.question_groups[i].translations) {
              Object.keys(data.question_groups[i].translations).forEach((language_id) => {
                if (
                  data.question_groups[i].translations[language_id] &&
                  data.question_groups[i].translations[language_id].video &&
                  data.question_groups[i].translations[language_id].video.file
                ) {
                  const key = `g-video-${i}-${language_id}`;
                  data.question_groups[i].translations[language_id].video.index = key;
                  formData.append(key, data.question_groups[i].translations[language_id].video.file);
                }
              });
            }

            // Child question groups
            if (data.question_groups[i].question_groups) {
              for (let j = 0; j < data.question_groups[i].question_groups.length; j++) {
                const category = data.question_groups[i].question_groups[j];

                for (let k = 0; k < category.questions.length; k++) {
                  if (category.questions[k].video && category.questions[k].video.file) {
                    const key = `video-${i}-${j}-${k}`;
                    category.questions[k].video.index = key;
                    formData.append(key, category.questions[k].video.file);
                  }

                  if (category.questions[k].translations) {
                    Object.keys(category.questions[k].translations).forEach((language_id) => {
                      if (
                        category.questions[k].translations[language_id] &&
                        category.questions[k].translations[language_id].video &&
                        category.questions[k].translations[language_id].video.file
                      ) {
                        const key = `video-${i}-${j}-${k}-${language_id}`;
                        category.questions[k].translations[language_id].video.index = key;
                        formData.append(key, category.questions[k].translations[language_id].video.file);
                      }
                    });
                  }

                  // Advanced feedback
                  if (category.questions[k].advanced_feedback) {
                    for (let x = 0; x < category.questions[k].advanced_feedback.length; x++) {
                      const feedback = category.questions[k].advanced_feedback[x];

                      if (feedback.video && feedback.video.file) {
                        const key = `adv-video-${i}-${j}-${k}-${x}`;
                        feedback.video.index = key;
                        formData.append(key, feedback.video.file);
                      }

                      if (feedback.translations) {
                        Object.keys(feedback.translations).forEach((language_id) => {
                          if (
                            feedback.translations[language_id] &&
                            feedback.translations[language_id].video &&
                            feedback.translations[language_id].video.file
                          ) {
                            const key = `adv-video-${i}-${j}-${k}-${x}-${language_id}`;
                            feedback.translations[language_id].video.index = key;
                            formData.append(key, feedback.translations[language_id].video.file);
                          }
                        });
                      }
                    }
                  }
                }
              }
            }
          }

          // Loop through the questions, add the index of the question to the video object
          for (let i = 0; i < data.questions.length; i++) {
            if (data.questions[i].video && data.questions[i].video.file) {
              const key = `video-${i}`;
              data.questions[i].video.index = key;
              formData.append(key, data.questions[i].video.file);
            }

            if (data.questions[i].translations) {
              Object.keys(data.questions[i].translations).forEach((language_id) => {
                if (
                  data.questions[i].translations[language_id] &&
                  data.questions[i].translations[language_id].video &&
                  data.questions[i].translations[language_id].video.file
                ) {
                  const key = `translation-video-${i}-${language_id}`;
                  data.questions[i].translations[language_id].video.index = key;
                  formData.append(key, data.questions[i].translations[language_id].video.file);
                }
              });
            }

            // Answer answers
            for (let j = 0; j < data.questions[i].answers.length; j++) {
              if (data.questions[i].answers[j].answers && data.questions[i].answers[j].answers.length) {
                for (let k = 0; k < data.questions[i].answers[j].answers.length; k++) {
                  if (
                    data.questions[i].answers[j].answers[k].video &&
                    data.questions[i].answers[j].answers[k].video.file
                  ) {
                    const key = `video-${i}-${j}-${k}`;
                    data.questions[i].answers[j].answers[k].video.index = key;
                    formData.append(key, data.questions[i].answers[j].answers[k].video.file);
                  }
                }
              }
            }

            // Advanced feedback
            if (data.questions[i].advanced_feedback) {
              for (let j = 0; j < data.questions[i].advanced_feedback.length; j++) {
                if (data.questions[i].advanced_feedback[j].video && data.questions[i].advanced_feedback[j].video.file) {
                  const key = `adv-video-${i}-${j}`;
                  data.questions[i].advanced_feedback[j].video.index = key;
                  formData.append(key, data.questions[i].advanced_feedback[j].video.file);
                }
              }
            }
          }

          // Append relevant json
          formData.append('data', angular.toJson(data));
          return formData;
        },
      }).then(
        (response) => {
          game = response.data;
          return response.data;
        },
        (error) => {
          throw error.data;
        },
      );
    }

    function transferGames(data) {
      return $http({
        method: 'PUT',
        url: `${serverAddress}game/transfer`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function deleteGame(data) {
      return $http({
        method: 'PUT',
        url: `${serverAddress}game/delete`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function archiveGame(data) {
      return $http({
        method: 'PUT',
        url: `${serverAddress}game/archive`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getQuestion(questionId) {
      return $http({
        method: 'GET',
        url: `${serverAddress}question/${questionId}`,
        params: {
          domain: domainService.domain,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getQuestions(gameId, params) {
      return $http({
        method: 'GET',
        url: `${serverAddress}question`,
        params: {
          game_id: gameId,
          ...params,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function addQuestion(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}question`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function updateQuestion(data) {
      return $http({
        method: 'PUT',
        url: `${serverAddress}question`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function addQuestionGroup(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}game/question_group`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getTracks() {
      return $http({
        method: 'GET',
        url: `${serverAddress}game/tracks`,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getFields() {
      return $http({
        method: 'GET',
        url: `${serverAddress}game/fields`,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getGameTypes() {
      const gameTypes = [
        {
          key: 'jump',
          directory: 'jump',
          name: 'Jump',
          resolution: null,
        },
        {
          key: 'match',
          directory: 'match',
          name: 'Match',
          resolution: null,
        },
        {
          key: 'scramble',
          directory: 'scramble',
          name: 'Scramble',
          resolution: null,
        },
        {
          key: 'recall',
          directory: 'recall',
          name: 'Recall',
          resolution: null,
        },
        {
          key: 'trivia',
          directory: 'trivia',
          name: 'Trivia',
          resolution: '16:9',
          instructor: true,
        },
        {
          key: 'grid',
          directory: 'sortit',
          name: 'Sort-it',
          resolution: '16:9',
        },
        {
          key: 'scenarios',
          directory: 'scenarios',
          name: 'Scenarios',
          resolution: '16:9',
        },
        {
          key: 'jeopardy',
          directory: 'jeopardy',
          name: 'Jeopardy!',
          resolution: '16:9',
          instructor: true,
        },
        {
          key: 'detective',
          directory: 'detective',
          name: 'Detective',
          resolution: '16:9',
        },
        {
          key: 'wof',
          directory: 'wheel-of-fortune',
          name: 'Wheel of Fortune',
          resolution: null,
        },
        {
          key: 'noodle',
          directory: 'noodle',
          name: 'Noodle™',
          resolution: null,
        },
        {
          key: 'category_quest',
          directory: 'category-quest',
          name: '<p>Category Quest <sup>(Beta)</sup></p>',
          gameTypeName: 'Category Quest',
          resolution: '16:9',
          new: true,
        },
      ];

      // @TODO: need to handle this on API side
      if (domainService.domain === 'tga' || domainService.domain === 'cfa') {
        gameTypes.push({
          key: '5s',
          directory: '5s',
          name: '5s',
          resolution: null,
        });
      }

      if (domainService.domain === 'tga' || domainService.domain === 'jeopardyaudition') {
        gameTypes.push({
          key: 'flash',
          directory: 'flash',
          name: 'Flash',
          resolution: '16:9',
          instructor: true,
        });
      }

      // Temporary override for WBS
      if (
        domainService.domain === 'tga' ||
        domainService.domain === 'beyondtruesuccess' ||
        domainService.domain === 'leadershipforum' ||
        domainService.domain === 'advantage' ||
        domainService.domain === 'ifpa' ||
        domainService.domain === 'paradox'
      ) {
        gameTypes.push({
          key: 'wbs',
          directory: 'wbs',
          name: 'WBS Custom Scenarios',
          resolution: null,
        });
      }

      gameTypes.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });

      return gameTypes;
    }

    function getGameDirectory(game_type) {
      const gameTypes = getGameTypes();
      for (let i = 0; i < gameTypes.length; i++) {
        if (gameTypes[i].key === game_type) {
          return gameTypes[i].directory;
        }
      }

      return false;
    }

    // eslint-disable-next-line no-unused-vars
    function getGameResolution(game_type) {
      const gameTypes = getGameTypes();

      for (let i = 0; i < gameTypes.length; i++) {
        if (gameTypes[i].key === game_type) {
          return gameTypes[i].resolution;
        }
      }

      return false;
    }

    function getGameUrl(g) {
      let url = `${urlService.composeProtocolHostPort($location)}/games/${getGameDirectory(g.game_type)}/${g.slug}`;
      if (g.privacy) {
        url += `?token=${g.token}`;
      }
      return url;
    }

    function getScormUrl(gameId, version) {
      if (authService.getAuthentication().twoFactorRemember && authService.getDeviceToken() !== null) {
        // eslint-disable-next-line max-len
        return `${serverAddress}game/scorm/${gameId}/?X-TGA-KEY=${
          authService.getAuthentication().token
        }&X-DEVICE-KEY=${authService.getDeviceToken()}&domain=${domainService.domain}&version=${version}`;
      }
      // eslint-disable-next-line max-len
      return `${serverAddress}game/scorm/${gameId}/?X-TGA-KEY=${authService.getAuthentication().token}&domain=${
        domainService.domain
      }&version=${version}`;
    }

    function uploadTranslation(g, files) {
      return $http({
        method: 'POST',
        url: `${serverAddress}game/translation/upload`,
        // IMPORTANT!!! You might think this should be set to 'multipart/form-data'
        // but this is not true because when we are sending up files the request
        // needs to include a 'boundary' parameter which identifies the boundary
        // name between parts in this multi-part request and setting the Content-type
        // manually will not set this boundary parameter. For whatever reason,
        // setting the Content-type to 'false' will force the request to automatically
        // populate the headers properly including the boundary parameter.
        headers: { 'Content-Type': undefined },
        // This method will allow us to change how the data is sent up to the server
        // for which we'll need to encapsulate the farmer data in 'FormData'
        transformRequest(data) {
          const formData = new FormData();
          formData.append('game_id', data.game_id);
          formData.append('token', data.token);
          formData.append('domain', data.domain);
          // now add all of the assigned files
          for (let i = 0; i < data.files.length; i++) {
            // add each file to the form data
            formData.append('file', data.files[i]);
          }
          return formData;
        },
        data: {
          game_id: g.game_id,
          token: g.token,
          domain: domainService.domain,
          files,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function publishToDocebo(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}game/docebo`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function generateQuestions(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}question/generate`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function generateTranslation(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}game/generate/translation`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function checkGameName(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}game/check`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    return {
      destroy,
      setCurrentGame,
      currentGame,
      clearGame,
      getGame,
      getGameInfo,
      getGames,
      getAllGames,
      getArchivedGames,
      addGame,
      updateGame,
      deleteGame,
      archiveGame,
      getQuestion,
      getQuestions,
      addQuestion,
      updateQuestion,
      addQuestionGroup,
      getTracks,
      getFields,
      getGameTypes,
      getGameDirectory,
      getGameUrl,
      getScormUrl,
      uploadTranslation,
      transferGames,
      publishToDocebo,
      generateQuestions,
      generateTranslation,
      checkGameName,
    };
  },
]);
